import React, { useRef } from 'react';
import { Icons } from '../../../Icons/Icons.tsx';
import { NavLink } from 'react-router-dom';

export interface BouncingIconWithTextProps {
  iconVariant: string;
  to: string;
  state?: Record<string, unknown>;
  text?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  preventNavigation?: boolean;
}

export const BouncingIconWithText: React.FC<BouncingIconWithTextProps> = (props) => {
  const { iconVariant, to, state = {}, text = '', onClick, preventNavigation = false } = props;
  const iconRef = useRef<HTMLElement>(null);

  const handleMouseEnter = (_event: React.MouseEvent<HTMLAnchorElement>) => {
    if (iconRef && iconRef.current) {
      iconRef.current.classList.add('fa-bounce');
    }
  };

  const handleMouseLeave = (_event: React.MouseEvent<HTMLAnchorElement>) => {
    if (iconRef && iconRef.current) {
      iconRef.current.classList.remove('fa-bounce');
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (typeof onClick === 'function') {
      onClick(event);
    }

    if (preventNavigation) {
      event.preventDefault();
    }
  };

  return (
    <NavLink className={({ isActive }) =>
      `flex flex-row text-app-lg2 mb-app-sm hover:text-app-secondary ${isActive ? 'text-app-secondary' : 'text-app-gray-light'
      }`
    }
      to={to} state={state}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      <div className='w-[20px] text-center mr-app-sm'>
        <Icons forwardRef={iconRef} variant={iconVariant} />
      </div>
      <p className='flex-1 font-thin !important'>{text}</p>
    </NavLink>
  );
};
